import React, { useState } from "react"
import { Link, useHistory, useLocation } from "react-router-dom"
import moment from "moment"

import loader from "@/assets/img/loader.svg"
import brandImage from "@/assets/img/login/brand.svg"

import "@/assets/scss/pages/login.scss"

import Api from "../../../_helpers/Api"
import { useLanguageContext } from "../../../_providers/Language"
import { trans } from "../../../_providers/Translation"
import { getErrorMessage } from "./helpers"

// линкът от писмото носи типа вход като is_admin=true/false (или 1/0)
const readIsAdmin = (searchParams) => {
  let value = String(searchParams.get("is_admin") || "").toLowerCase()

  return ["1", "true"].includes(value)
}

function ResetPassword() {
  const languages = useLanguageContext()
  const history = useHistory()
  const location = useLocation()

  const searchParams = new URLSearchParams(location.search)

  const token = searchParams.get("token") || ""
  const email = searchParams.get("email") || ""
  const isAdmin = readIsAdmin(searchParams)
  const loginPath = "/login/" + (isAdmin ? "admin" : "partners")

  const [lang, setLang] = useState(searchParams.get("lang") || "en")

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault()

    if (loading) {
      return
    }

    let data = new FormData(e.target)

    if (data.get("password") !== data.get("password_confirmation")) {
      setError(trans("login.resetPassword.mismatch", {}, lang))
      return
    }

    setLoading(true)
    setError(null)

    Api.post("reset-password", {
      email: data.get("email"),
      is_admin: data.get("is_admin") === "1",
      token: data.get("token"),
      password: data.get("password"),
      password_confirmation: data.get("password_confirmation"),
    })
      .then(() => {
        history.replace(loginPath + "?password_reset=1")
      })
      .catch((err) => {
        setError(getErrorMessage(err, trans("login.resetPassword.fail", {}, lang)))
        setLoading(false)
      })
  }

  const handleLangChange = (e) => {
    setLang(e.target.value)
  }

  return (
    <section id="login">
      <img src={brandImage} alt="brand" />

      <form onSubmit={handleSubmit} className="password-reset">
        <div className="top">
          <Link to={loginPath} className="back">
            {trans("login.twoFactor.back", {}, lang)}
          </Link>
          <select value={lang} onChange={handleLangChange}>
            {languages.map((language) => (
              <option key={language.id} value={language.code}>
                {language.name}
              </option>
            ))}
          </select>
        </div>

        <h1>{trans("login.resetPassword.head", {}, lang)}</h1>

        {!token || !email ? (
          <div className="message error">
            {trans("login.resetPassword.invalidLink", {}, lang)}
          </div>
        ) : (
          <>
            <p>
              {trans("login.resetPassword.description", { email: email }, lang)}
            </p>

            <input type="hidden" name="email" value={email} />
            <input type="hidden" name="is_admin" value={isAdmin ? "1" : "0"} />
            <input type="hidden" name="token" value={token} />

            <div className="row">
              <div className="col">
                <label>{trans("login.resetPassword.password", {}, lang)}</label>
                <input
                  type="password"
                  name="password"
                  required
                  autoFocus
                  autoComplete="new-password"
                  placeholder={trans("login.resetPassword.password", {}, lang)}
                  className={error ? "validate" : ""}
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label>
                  {trans("login.resetPassword.passwordConfirmation", {}, lang)}
                </label>
                <input
                  type="password"
                  name="password_confirmation"
                  required
                  autoComplete="new-password"
                  placeholder={trans(
                    "login.resetPassword.passwordConfirmation",
                    {},
                    lang
                  )}
                  className={error ? "validate" : ""}
                />
              </div>
            </div>

            {error && <div className="message error">{error}</div>}

            <div className="row">
              <div className="col actions">
                {loading ? (
                  <img src={loader} alt="loading" />
                ) : (
                  <button className="button button-primary">
                    {trans("login.resetPassword.button", {}, lang)}
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </form>

      <p>© EUS {moment().format("YYYY")}. All rights reserved.</p>
    </section>
  )
}

export default ResetPassword
